import React, { useState, useEffect } from "react";

import live from "../../../../../assets/images/AdminLiveProfile/live 1.png";
import liveperson from "../../../../../assets/images/AdminLiveProfile/video-chat.png";
import discount from "../../../../../assets/images/AdminLiveProfile/discount 1.png";
import price from "../../../../../assets/images/AdminLiveProfile/calendar.png";
import clock from "../../../../../assets/images/AdminLiveProfile/clock.png";
import "../../../../../assets/CSS/LiveChatProfie.css";
import axios from "axios";
import { Markup } from "interweave";

const LiveChatProfile = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/livechat_event_profile`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  return (
    <>
      <div className="card card-bg head-line mt-4 mb-2 mb-3">
        <div className="text-light d-flex p-2">
          <div className="faTrophy">
            <img src={live} alt="" className="img-fluid mx-2" />
          </div>
          <h4 className="mx-3 text-white p-2">Live Chat profile</h4>
        </div>
      </div>

      <div className="card card-bg">
        <div className="row">
          <div className="col-md-6 p-3">
            <div className="px-2">
              <img src={liveperson} alt="" className="img-fluid live-person" />
            </div>
          </div>

          <div className="col-md-6 p-3">
            <h4 className="text-light">Instructions</h4>
            <p className="text-light">{events.title}</p>

            <p className="text-light">
              <Markup content={events.description} />
            </p>

            <div className="registration-btn d-flex p-3 rounded-2 col-md-6 ">
              <img src={discount} className="img-fluid" alt="" width={50} />
              <div className="mx-2">
                <span className="text-dark">Cost per minute</span>
                <br></br>
                <span className="fw-bold text-dark">{events.cost} $</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-0 my-3">
        <div className=" col-md-3 d-flex bg-warning rounded-3 py-2 me-3 date-down">
          <span>
            <img src={price} alt="" />
          </span>
          <div className="price-content mx-2">
            <span className="text-dark">Date</span>
            <br></br>
            <span className="fw-bold text-dark">21th November</span>
          </div>
        </div>

        <div className="col-md-3 d-flex bg-success rounded-3 py-2">
          <span>
            <img src={clock} alt="" />
          </span>
          <div className="price-content mx-2">
            <span className="text-light">Time</span>
            <br></br>
            <span className="fw-bold text-warning">21th November</span>
          </div>
        </div>
      </div>

      <div className="down-modify-button mt-5 ">
        <button className="btn btn-warning px-5 fw-bold text-light">
          Edit
        </button>
        <button className="btn text-warning px-5 mx-3 modify-btn-2">
          Delete
        </button>
      </div>
    </>
  );
};

export default LiveChatProfile;
